import React from 'react'
import './ProgressTracker.scss'
import { useTranslation } from 'react-i18next'

interface ProgressTrackerProps {
  steps: number
  currentStep: number
  setStepTo: (step: number) => void
  i18nName: string
}

export const ProgressTracker: React.FC<ProgressTrackerProps> = ({
  steps,
  currentStep,
  setStepTo,
  i18nName,
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: i18nName })
  if (steps < 2) {
    return <></>
  }
  return (
    <div className="progress-tracker">
      {Array.from({ length: steps }).map((_, index) => (
        <div
          key={index}
          className={`progress-tracker__dot ${
            index < currentStep ? 'progress-tracker__dot--completed' : ''
          }${
            index + 1 <= currentStep ? ' progress-tracker__dot--can-click' : ''
          }`}
          onClick={() => {
            if (index + 1 <= currentStep) {
              setStepTo(index + 1)
            }
          }}
        >
          {t(`stepHeaders.${index + 1}`, '') ? (
            <div className="progress-tracker__dot__tooltip">
              ({(index + 1).toString()}) {t(`stepHeaders.${index + 1}`)}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  )
}
